// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_defined.js
// module id = 70
// module chunks = 47